module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_31.124cc1d0.jpg";